import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import NotificationOfAssetsWidget from '../../../widgets/durableArticlesWidget/notificationOfAssets/NotificationOfAssetsWidget'
import { getNotificationOfAssets } from '../../../redux/actions/notificationOfAssets'

export default function ManageNotification({
  useType,
  title,
  _isIncomeExpenseApprover,
  _isManagement,
}) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getNotificationOfAssets('', useType)
      // console.log('response ', response)
      // response.model.disabled = true
      setSchema(response.model)
      // setSchema(mockSchema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal
        isIncomeExpenseApprover={_isIncomeExpenseApprover}
        isManagement={_isManagement}
      >
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal
        isIncomeExpenseApprover={_isIncomeExpenseApprover}
        isManagement={_isManagement}
      >
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal
        isIncomeExpenseApprover={_isIncomeExpenseApprover}
        isManagement={_isManagement}
      >
        <ContentHeader header={schema.header} subHeader={title || ''} isNotCallApi />

        <NotificationOfAssetsWidget schema={schema} useType={useType} />

        <br />
      </SidebarProposal>
    </div>
  )
}
